import { api } from '../config/api'

const baseEndpoint = '/AgeRangeApi'

export const getAgeRanges = () => api.get(baseEndpoint)
